// Carry Roll FidelitySelector — flight-model fidelity selector (4.5). P3 makes it meaningful.

import { useStore } from '../../store';
import { Fidelity } from '@carry-roll/shared-types';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function FidelitySelector() {
  const fidelity = useStore((s) => s.fidelity);
  const setFidelity = useStore((s) => s.setFidelity);
  return (
    <div data-testid="fidelity-selector" className="flex items-center justify-between">
      <span className="field-label inline-flex items-center">
        Flight model fidelity
        <HelpTooltip label="Flight model fidelity">Full integrates drag, lift, and spin decay step-by-step (accurate, slower). Basic uses a closed-form reduced model (fast, approximate).</HelpTooltip>
      </span>
      <div className="flex gap-1">
        {([Fidelity.Full, Fidelity.Basic] as Fidelity[]).map((f) => (
          <button
            key={f}
            type="button"
            className="btn"
            aria-pressed={fidelity === f}
            onClick={() => setFidelity(f)}
            style={fidelity === f ? { borderColor: 'var(--color-accent)', color: 'var(--color-accent)' } : undefined}
          >
            {f}
          </button>
        ))}
      </div>
    </div>
  );
}
